import moment from 'moment';

import * as actions from './actions';
import * as getters from './getters';

import {
    CLEAR_SEARCH,
    FETCH_COUNTRIES,
    FETCH_USER_LOCATION,
    SET_MOCK_LOCATION,
    SET_SCREEN_TYPE,
    SET_COUNTRY,
    FETCH_LOCATIONS,
    SET_PROMO_CODE,
    SET_DRIVER_AGE,
    SET_PASSENGERS,
    SET_TRANSMISSION,
    SET_DROPOFF_DIFFERENT,
    SET_DROPOFF_LOCATION,
    SET_PICKUP_DATE,
    SET_PICKUP_TIME,
    SET_DROPOFF_DATE,
    SET_DROPOFF_TIME,
    SET_PICKUP_LOCATION,
    SET_SEARCH_STATE,
    SET_GUEST_TOKEN,
    SET_QUOTE_ID,
    SET_CURRENCY,
    SET_AGENT_ID,
    SET_BOOKING_REFERENCE,
    SET_UPDATE_QUOTE,
    SET_CANCEL_DONATION,
    SET_LAST_NAME,
    USER_DEV_LOCATION,
    SET_RECREATE_QUOTE,
} from './mutation-types';

const tomorrow = moment().add(1, 'days');
const dayAfterTomorrow = tomorrow.clone().add(1, 'days');

window.greenmotion = window.greenmotion || {};
let config = Object.assign({ currency: null, guestToken: null, userToken: null }, JSON.parse(localStorage.getItem('HTTP')));
// initial state
const initialState = {
    search: {
        country: null,
        currency: config.currency,
        driverAge: 30,
        dropoffDate: dayAfterTomorrow.format('YYYY-MM-DD'),
        dropoffDifferent: false,
        dropoffLocation: null,
        dropoffTime: '09:00',
        guestToken: config.guestToken,
        location: null,
        passengers: '',
        pickupDate: tomorrow.format('YYYY-MM-DD'),
        pickupLocation: null,
        pickupTime: '09:00',
        promoCode: '',
        quoteId: null,
        transmission: '',
        agentId: null,
        updating: false,
        cancel_donation: false,
        last_name: '',
        reference: '',
    },
    initialLocation: window.greenmotion.location_id || null,
    layout: window.greenmotion.layout || 'standard',
    countries: [],
    locations: [],
    userLocation: [],
    // mobile is less than 768, tablet is less than 1024, desktop is greater than 1024
    screenType: window.screen.width > 1024 ? 'desktop' : window.screen.width > 768 ? 'tablet' : 'mobile',
    recreateQuote: null,
};

// mutations
const mutations = {
    [FETCH_COUNTRIES](state, countries) {
        state.countries = countries;
    },

    [USER_DEV_LOCATION](state, value) {
        state.userLocation['dev'] = value;
    },

    [FETCH_USER_LOCATION](state, location) {
        state.userLocation = location;
    },

    [SET_MOCK_LOCATION](state, location) {
        state.userLocation['countryCode'] = location;
    },

    [SET_SCREEN_TYPE](state, screenType) {
        state.screenType = screenType;
    },

    [SET_COUNTRY](state, country) {
        state.search.country = country;
    },

    [FETCH_LOCATIONS](state, locations) {
        state.locations = locations;
    },

    [SET_PROMO_CODE](state, code) {
        state.search.promoCode = code;
    },

    [SET_DRIVER_AGE](state, age) {
        state.search.driverAge = age;
    },

    [SET_PASSENGERS](state, passengers) {
        state.search.passengers = passengers;
    },

    [SET_TRANSMISSION](state, transmission) {
        state.search.transmission = transmission;
    },

    [SET_DROPOFF_DIFFERENT](state, different) {
        state.search.dropoffDifferent = different;
    },

    [SET_DROPOFF_LOCATION](state, different) {
        state.search.dropoffLocation = different;
    },

    [SET_PICKUP_DATE](state, date) {
        state.search.pickupDate = moment(date).format('YYYY-MM-DD');
    },

    [SET_PICKUP_TIME](state, time) {
        state.search.pickupTime = time;
    },

    [SET_DROPOFF_DATE](state, date) {
        state.search.dropoffDate = moment(date).format('YYYY-MM-DD');
    },

    [SET_DROPOFF_TIME](state, time) {
        state.search.dropoffTime = time;
    },

    [SET_PICKUP_LOCATION](state, location) {
        state.search.pickupLocation = location;
    },

    [SET_DROPOFF_LOCATION](state, location) {
        state.search.dropoffLocation = location;
    },

    [SET_SEARCH_STATE](state, payload) {
        state.search[payload.key] = payload.value;
    },

    [SET_AGENT_ID](state, agentId) {
        state.search.agentId = agentId;
    },

    [SET_BOOKING_REFERENCE](state, reference) {
        state.search.reference = reference;
    },

    [SET_QUOTE_ID](state, id) {
        state.search.quoteId = id;
    },

    [SET_CURRENCY](state, currency) {
        state.search.currency = currency;
    },

    [SET_LAST_NAME](state, last_name) {
        state.search.last_name = last_name;
    },

    [SET_GUEST_TOKEN](state, token) {
        state.search.guestToken = token;
    },

    [SET_UPDATE_QUOTE](state, updating) {
        state.search.updating = updating;
    },

    [SET_CANCEL_DONATION](state, cancel) {
        state.search.cancel_donation = cancel;
    },

    [CLEAR_SEARCH](state) {
        state.search = initialState.search;
    },

    [SET_RECREATE_QUOTE](state, id) {
        state.recreateQuote = id;
    },
};

export default {
    state: { ...initialState },
    actions,
    getters,
    mutations,
};
